module.exports = require("./../../_gen/openfl/media/ID3Info");